module.exports = __webpack_public_path__ + "img/ges.e2fe5087.svg";